<template>
    <div>
        <el-row>
            <h2>更新订单金额</h2>
        </el-row>
        <el-row>
            <el-col>
                <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:0" :model="searchForm"
                         ref="searchForm">
                    <el-form-item label="日期范围：">
                        <el-date-picker
                                v-model="value7"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions2" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="search">更新</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      searchForm: {},
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      value7: '',
    };
  },
  methods: {
    queryList() {
      const params = {
        SERVICE_ID: '11000',
        OTYPE: 9,
        START_DAY: this.value7[0],
        END_DAY: this.value7[1],
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '更新成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    search() {
      this.queryList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/updateOrder.vue